import React from 'react';
import AudienceToggle from './AudienceToggle';

const FloatingAudienceToggle = ({ audience = 'd2c' }) => {
  return (
    <div className="fixed top-16 inset-x-0 z-40 flex justify-center px-4 py-2 pointer-events-none">
      <AudienceToggle audience={audience} className="pointer-events-auto" />
    </div>
  );
};

/** Reserves space so hero layout matches the fixed toggle position */
export const AUDIENCE_TOGGLE_SPACER_CLASS = 'h-[52px] sm:h-[56px] mb-3 sm:mb-4';

export default FloatingAudienceToggle;
